<template>
  <v-row class="caption">
    <v-col cols="3"> Porterage </v-col>
    <v-col style="min-width: 200px; max-width: 200px">
      {{ porterage.rate }}
    </v-col>
    <v-col>
      <span>x {{ porterage.totalCountOfItems }}</span>
    </v-col>
    <v-col style="min-width: 90px; max-width: 90px">
      <span></span>
    </v-col>
    <v-col class="d-flex justify-center" style="min-width: 140px; max-width: 140px; border: 1px solid lightgrey">
      <v-tooltip right>
        <template v-slot:activator="{ on }">
          <span v-on="on">{{ compiledTotal }}</span>
        </template>
        <div>
          <div>{{ displayTotalBreakdown }}</div>
        </div>
      </v-tooltip>
    </v-col>
  </v-row>
</template>

<script>
import money from "@/services/money";
export default {
  props: {
    porterage: Object,
  },
  computed: {
    displayTotalBreakdown() {
      let total = this.porterage.totalCountOfItems;
      return `= ${total} * ${this.porterage.rate}`;
    },
    compiledTotal() {
      if (!this.porterage.compiledTotal) return "$ --";
      return `$ ${money.format(this.porterage.compiledTotal, { precision: 2 })}`;
    },
  },
};
</script>
